export default "__VITE_ASSET__DfBVI85x__"